import { call, put, takeLatest } from 'redux-saga/effects';
import { getUserMappings } from 'api/AnalyticsAPI';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as t from './actionTypes';

export function* fetchUserMappings() {
  try {
    const data = yield call(getUserMappings);
    yield put(actions.fetchUserMappingsResponse(data));
  } catch (error) {
    yield put(actions.fetchUserMappingsError(error));
  }
}

addToRootSaga([takeLatest(t.FETCH_USER_MAPPINGS_REQUEST, fetchUserMappings)]);
